import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import IllegalConstructionSidebar from "../IllegalConstructionSidebar/IllegalConstructionSidebar";
import { ZoneNameCommanDDL } from "../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { HeaderIllegal } from "../HeaderIllegal";
import { DesignationCommanDDL } from "../../../../../../Components/IllegalDDL/DesignationCommanDDL";

export const GroupAttendanceIllegalGrid = () => {

    const { t } = useTranslation()
    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };


    const [DashType, setDashType] = useState(localStorage.getItem('DashType') ? localStorage.getItem('DashType') : 1)

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])


    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const DataObj = ({
        isCountLoading: '',
        Language: Language.Label
    })

    const [DesignationNameID, setDesignationNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    return (
        <>
            <HeaderIllegal />
            <div className="wrapper bg-change">

                <IllegalConstructionSidebar />

                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            {/* Group Attendance */}
                            <h5 className="text-dark fw-bold ps-3 pt-3 all_heading_fontsize">
                                {t('EncroachmentDashboard.GroupAttendance')}
                            </h5>
                        </div>
                    </div>
                    <div className="row ps-3 eic_table_styles py-2" >

                        <div class="col-12 col-lg-3 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                            <input type="date" placeholder="" name="date" className="form-control" id="email" required />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ToDate')}</label><br />
                            <input type="date" placeholder="" name="date" className="form-control" id="email" required />
                        </div>




                        <div className="col-12 col-lg-4 col-md-4  mt-3">

                            <button type="button" className="btn btn-success mx-3 mt-4">Search</button>
                            <button type="button" className="btn btn-danger mt-4">Clear</button>
                        </div>

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.date')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.GroupAttendancetime')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.EmployeeName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.PathakName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Shift')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Photo')}</th>
                                                {/* <th className="text-center">{t('EncroachmentDashboard.Action')}</th> */}
                                            </tr>

                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td className="py-1" align="center">1</td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center">
                                                    <button className="view_button">
                                                        {t('EncroachmentDashboard.View')}
                                                    </button>
                                                </td>

                                                {/* <td className="text-center">

                                                                <span className=""
                                                                    onClick={() => {
                                                                        handleShare()
                                                                    }}
                                                                    title="Share">
                                                                    <i className="fa-solid fa-share-from-square mx-2 text-success cursor-pointer"></i>
                                                                </span>



                                                            </td> */}

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>


                        </div>
                    </div>

                </div>
            </div>


        </>
    )
}

